import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Select from 'components/common-sfims/form/Select';
import RangeMonthPicker from 'components/pages/sfms/dashboard/trend/search/RangeMonthPicker';
import { array2ValueAndText } from 'function/convert';
import { getText } from 'function/language';
import { getLoginInform } from 'function/login';
import useBUState from 'global/buState';
import usePlantState from 'global/plantState';

/**
 * 대시보드 > 추이 대시보드 - 검색
 */
const Content = ({ disabled, type, value, onChange }) => {
  /* variable */
  const { fatoryCodeSeq } = getLoginInform();

  /* recoil */
  const { bu } = useBUState();
  const {
    plant: { hasReads: hasReadPlants }
  } = usePlantState();

  /* state */
  // 기간
  const [period, setPeriod] = useState({});
  // 선택한 BU
  const [selectBU, setSelectBU] = useState('');
  // 선택한 공장
  const [selectPlant, setSelectPlant] = useState(fatoryCodeSeq);

  /* watch */
  useEffect(() => {
    let period = {};
    let plant =
      value.factoryCodeSeqList?.length === 1
        ? value.factoryCodeSeqList?.[0]
        : 0;

    switch (type) {
      // 원료 가격 추이
      case 0:
        period = {
          startPriceYm: value.startPriceYm,
          endPriceYm: value.endPriceYm
        };
        plant = fatoryCodeSeq;

        break;

      // 제품 생산량 추이
      case 1:
        period = {
          startProdYm: value.startProdYm,
          endProdYm: value.endProdYm
        };

        break;

      // 원재료비 추이
      case 2:
        period = {
          startPriceYm: value.startPriceYm,
          endPriceYm: value.endPriceYm
        };

        break;
    }

    setPeriod(period);
    setSelectBU(value.buCode);
    setSelectPlant(plant);
  }, [value]);
  useEffect(() => {
    // BU 선택 시
    if (selectBU) {
      // 원료 가격 추이인 경우 해당 BU에 속한 첫번째 공장 선택
      // 제품 생산량 / 원재료비 추이인 경우 전체 공장 선택
      setSelectPlant(
        type === 0
          ? hasReadPlants.find(({ buCode } = {}) => buCode === selectBU)?.seq ??
              ''
          : 0
      );
    }
  }, [selectBU]);

  /* event */
  // 검색
  const onSubmit = () => {
    const params = { ...period };

    if (type === 0) {
      // 원료 가격 추이
      Object.assign(params, { factoryCodeSeq: selectPlant });
    } else {
      // 제품 생산량 / 원재료비 추이
      Object.assign(params, {
        buCode: selectBU,
        factoryCodeSeqList: selectPlant > 0 ? [selectPlant] : []
      });
    }

    onChange(params);
  };

  /* view */
  return (
    <Form.Group className="mb-3">
      <Row className="ms-0 me-0 mt-3">
        <RangeMonthPicker type={type} value={period} onUpdate={setPeriod} />
        {type > 0 && (
          <Col sm={2} className="ps-1 pe-1">
            <Select
              datas={array2ValueAndText(bu, 'buCode', 'buName')}
              placeholder="selectBU"
              value={selectBU}
              className="w-100"
              onChange={({ target: { value } }) => setSelectBU(value)}
            />
          </Col>
        )}
        <Col sm={2} className="ps-1 pe-1">
          <Select
            datas={array2ValueAndText(
              hasReadPlants.filter(
                ({ buCode } = {}) => !selectBU || buCode === selectBU
              ),
              'seq',
              'pltCode'
            )}
            placeholder="selectFactory"
            showAll={type > 0}
            value={selectPlant}
            className="w-100"
            onChange={({ target: { value } }) => setSelectPlant(value)}
          />
        </Col>
        <Col sm="auto" className="ps-1 pe-1">
          <Button disabled={disabled} size="sm" onClick={onSubmit}>
            {getText('search')}
          </Button>
        </Col>
      </Row>
    </Form.Group>
  );
};

Content.propTypes = {
  // 검색 비활성화 여부
  disabled: PropTypes.bool,

  // 구분 (0: 원료 가격 추이, 1: 제품 생산량 추이, 2: 원재료비 추이)
  type: PropTypes.number,

  // 값
  value: PropTypes.object,

  // 값 변경 시 이벤트
  onChange: PropTypes.func
};
Content.defaultProps = {
  disabled: false,
  type: 0,
  value: {}
};

export default Content;
